import MultiEnumSelector from 'app/shared-components/MultiEnumSelector'
import EnumChipSelector from 'app/shared-components/EnumChipSelector'
import Select, {
    ObjectSelect,
} from 'app/shared-components/Select'

export const EnumComponents = {
    MultiEnumSelector,
    EnumChipSelector,
    Select,
    ObjectSelect,
}

export type EnumBaseConfig={
    allowedValues: Record<string, string>,
    useDropdown?: boolean,
    noSort?: boolean,
    showInColumns?: boolean,
    showOutOfRangeOption?: boolean,
    noNone?: boolean,
}

export type EnumComponentConfig = EnumBaseConfig & {
    componentName: keyof typeof EnumComponents,
}
